<span class="circle"
      *ngIf="params?.value"
      [ngClass]="getCircleClass(params?.value)">
</span>
<span>
    {{params?.value}}
</span>